/* SQUISHY&CO - Boost conversion
 * 1) Rotation de la barre d'infos
 * 2) Jauge "livraison offerte" : rendue par Liquid puis tenue a jour en direct
 *    (tiroir panier + encadre page produit) a chaque modification du panier.
 *    Rappelle les frais de livraison estimes, barres une fois le seuil atteint.
 */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
   * 1. Barre d'infos rotative
   * ------------------------------------------------------------------ */
  function initTopbar() {
    var bar = document.querySelector('[data-sq-topbar]');
    if (!bar) return;

    var items = bar.querySelectorAll('.sq-topbar__item');
    if (items.length < 2) return;

    var speed = (parseInt(bar.getAttribute('data-speed'), 10) || 5) * 1000;
    var index = 0;

    setInterval(function () {
      items[index].classList.remove('is-active');
      index = (index + 1) % items.length;
      items[index].classList.add('is-active');
    }, speed);
  }

  /* ------------------------------------------------------------------
   * 2. Jauge livraison offerte
   * ------------------------------------------------------------------ */
  var CFG = window.SQBoost || {};
  var THRESHOLD = parseInt(CFG.threshold, 10) || 0;
  var SHIPPING = CFG.shipping || '2,90';
  var STR = CFG.strings || {};
  var lastTotal = null;
  var inflight = null;

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function message(total) {
    if (total >= THRESHOLD) {
      return STR.unlocked || 'Bravo, la livraison est offerte !';
    }
    if (total > 0) {
      return (STR.remaining || 'Plus que {amount} pour la livraison offerte').replace(
        '{amount}',
        '<strong>' + money(THRESHOLD - total) + '</strong>'
      );
    }
    return STR.empty || '<strong>Livraison offerte</strong> dès ' + money(THRESHOLD) + ' d\'achat';
  }

  /* Rappel du montant en jeu : sinon la progression vise un montant inconnu. */
  function note(total) {
    var tpl =
      total >= THRESHOLD
        ? STR.noteUnlocked || 'Livraison : <s>{shipping} €</s> <strong>Offerte</strong>'
        : STR.note || 'Livraison estimée : <strong>{shipping} €</strong>';

    return '<p class="sq-fsb__note">' + tpl.split('{shipping}').join(SHIPPING) + '</p>';
  }

  function markup(total) {
    var pct = Math.max(0, Math.min(100, Math.round((total / THRESHOLD) * 100)));

    return (
      '<p class="sq-fsb__text">' +
      message(total) +
      '</p><div class="sq-fsb__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' +
      pct +
      '"><div class="sq-fsb__fill" style="width:' +
      pct +
      '%"></div></div>' +
      note(total)
    );
  }

  function fill(el, total) {
    if (total >= THRESHOLD) {
      el.classList.add('is-unlocked');
    } else {
      el.classList.remove('is-unlocked');
    }
    el.innerHTML = markup(total);
  }

  /* Tiroir panier : la jauge est injectee, et retiree si le panier est vide. */
  function paintDrawer(total) {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    var header = drawer.querySelector('.drawer__header');
    if (!header) return;

    var el = drawer.querySelector('.sq-fsb--drawer');

    if (!total || total <= 0) {
      if (el && el.parentNode) el.parentNode.removeChild(el);
      return;
    }

    if (!el) {
      el = document.createElement('div');
      el.className = 'sq-fsb sq-fsb--drawer';
      header.insertAdjacentElement('afterend', el);
    }

    fill(el, total);
  }

  /* Page produit : la jauge est deja rendue par Liquid, on la resynchronise. */
  function paintInline(total) {
    var nodes = document.querySelectorAll('.sq-fsb--inline');
    for (var i = 0; i < nodes.length; i++) fill(nodes[i], total);
  }

  function paintAll(total) {
    lastTotal = total;
    paintDrawer(total);
    paintInline(total);
  }

  function refresh() {
    if (!THRESHOLD || inflight) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    inflight = fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        paintAll(cart.total_price);
      })
      .catch(function () {})
      .then(function () {
        inflight = null;
      });
  }

  /* Detecte toute modification du panier pour rafraichir les jauges. */
  function hookFetch() {
    if (typeof window.fetch !== 'function') return;

    var original = window.fetch;

    window.fetch = function () {
      var target = arguments[0];
      if (target && typeof target === 'object' && target.url) target = target.url;

      var isCartMutation =
        typeof target === 'string' &&
        target.indexOf('/cart/') !== -1 &&
        /(add|change|update|clear)/.test(target);

      var out = original.apply(this, arguments);

      if (isCartMutation && out && typeof out.then === 'function') {
        out
          .then(function () {
            setTimeout(refresh, 80);
          })
          .catch(function () {});
      }

      return out;
    };
  }

  /* Le theme reconstruit le tiroir a chaque update : on replace la jauge. */
  function watchDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || !window.MutationObserver) return;

    new MutationObserver(function () {
      if (lastTotal > 0 && !drawer.querySelector('.sq-fsb--drawer')) paintDrawer(lastTotal);
    }).observe(drawer, { childList: true, subtree: true });
  }

  function boot() {
    initTopbar();

    if (THRESHOLD) {
      hookFetch();
      watchDrawer();
      refresh();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
